import CarbonEmissionPanel from "@components/Review/CarbonEmissionPanel";
import { Typography } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { PublicReviewBanner, ReviewBanner } from "@/components/Banner";
import { NavigationMenuLinks } from "@/components/NavigationMenu";
import { UserContext } from "@/contexts";
import { CustomUIMatch } from "@/hooks/useBreadcrumbs";

import { useReviewContext } from "./Review";

export const handle = {
  activeMenuLink: () => NavigationMenuLinks.restitution,
  breadcrumb: ({ reviewId: paramsReviewId }) => {
    const reviewId = paramsReviewId ?? localStorage.getItem("currentReviewId");
    return [
      {
        href: `/reviews/${reviewId}`,
        label: `navigation-menu:pages.analyse`,
      },
    ];
  },
} as CustomUIMatch["handle"];

function ReviewIndex() {
  const { reviewData, industryData } = useReviewContext();
  const { slug, reviewId } = useParams();

  const isPublicReview = !reviewId && slug;

  const { t } = useTranslation(["common", "review"]);

  if (!reviewData || !industryData) {
    return (
      <div className="grid place-items-center">
        <p>{t("common:loading")}</p>
      </div>
    );
  }

  const {
    company_name: companyName,
    period_start: periodStart,
    period_end: periodEnd,
  } = reviewData;

  const { user } = use(UserContext);

  return (
    <>
      <header className="mb-md">
        <Typography step="3" as="h1" weight="bold" className="mb-3xs">
          {t("review:title", { companyName })}
        </Typography>
        <Typography className="text-grayscale-dark">
          {t("formatter:date", { value: new Date(periodStart) })}
          &nbsp;-&nbsp;
          {t("formatter:date", { value: new Date(periodEnd) })}
        </Typography>
      </header>
      <CarbonEmissionPanel data={reviewData} />
      {!isPublicReview && user && (
        <ReviewBanner linkUrl={`/reviews/${reviewId}/feedback`} />
      )}
      {isPublicReview && !user && (
        <PublicReviewBanner companyName={companyName} />
      )}
    </>
  );
}

export default ReviewIndex;
